import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
// import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  // .use(LanguageDetector) // 自动检测用户语言
  .use(initReactI18next) // 将 i18next 绑定到 React
  .init({
    resources: {
      ar: { translation: require('./locales/ar/index.json') }, // 阿拉伯语
      vi: { translation: require('./locales/vi/index.json') }, // 越南语
      zh: { translation: require('./locales/zh/index.json') }, // 中文
      tw: { translation: require('./locales/tw/index.json') }, // 台湾
      th: { translation: require('./locales/th/index.json') }, // 泰语
      ru: { translation: require('./locales/ru/index.json') }, // 俄语
      de: { translation: require('./locales/de/index.json') }, // 德语
      cs: { translation: require('./locales/cs/index.json') }, // 捷克语
      hu: { translation: require('./locales/hu/index.json') }, // 匈牙利语
      pl: { translation: require('./locales/pl/index.json') }, // 波兰语
      fr: { translation: require('./locales/fr/index.json') }, // 法语
      es: { translation: require('./locales/es/index.json') }, // 西班牙语
      it: { translation: require('./locales/it/index.json') }, // 意大利语
      ja: { translation: require('./locales/ja/index.json') }, // 日语
      ko: { translation: require('./locales/ko/index.json') }, // 韩语
      pt: { translation: require('./locales/pt/index.json') }, // 葡萄牙语
      id: { translation: require('./locales/id/index.json') }, // 印尼语
      ro: { translation: require('./locales/ro/index.json') }, // 罗马尼亚语
      tr: { translation: require('./locales/tr/index.json') }, // 土耳其语
      tl: { translation: require('./locales/tl/index.json') }, // 菲律宾语
      uk: { translation: require('./locales/uk/index.json') }, // 乌克兰语
      en: { translation: require('./locales/en/index.json') }, // 英文
      km: { translation: require('./locales/km/index.json') }, // 高棉语
    },
    fallbackLng: 'zh', // 默认语言
    interpolation: {
      escapeValue: false, // React 已经对 XSS 做了处理
    },
    detection: {
      order: ['querystring', 'navigator', 'htmlTag'],
    },
  });

export default i18n;
